import { CustomFieldAssignmentsDto } from '../custom-field-assignments-dto';
import { PackagingComponentDto } from './packaging-component-dto';

export class PackagingComponentEntryDto {
  entryId?: number;
  hasInternalTracking = false;
  underlyingComponent!: PackagingComponentDto;
  customFields: CustomFieldAssignmentsDto | null = null;
}
